export default __webpack_public_path__ + "static/media/hotel.ff0fe7dd.jpg";